const TargetMenu = () => {
	const spyNav = document.querySelector("[data-spy-nav]");
	const spyType = document.querySelector("[data-spy-type]")?.getAttribute("data-spy-type") || "scroll";
	const activeClass = "active";

	// ===== TAB MODE =====
	if (spyNav && spyType === "tab") {
		const tabSections = document.querySelectorAll('[data-spy-section="tab"]');
		const links = spyNav.querySelectorAll("[data-spy-link]");

		const clearHash = () => history.replaceState(null, "", location.pathname + location.search);

		const activate = (id) => {
			tabSections.forEach((section) => {
				section.classList.toggle(activeClass, section.id === id);
			});
			links.forEach((link) => {
				const linkId = link.getAttribute("href")?.replace("#", "");
				link.classList.toggle(activeClass, linkId === id);
			});
		};

		const hashId = location.hash ? location.hash.slice(1) : "";
		const initialId = hashId && document.getElementById(hashId) ? hashId : tabSections[0]?.id;
		if (initialId) {
			activate(initialId);
			if (hashId) clearHash();
		}

		links.forEach((link) => {
			link.addEventListener(
				"click",
				() => {
					const id = link.getAttribute("href")?.slice(1);
					if (!id) return;
					activate(id);

					requestAnimationFrame(clearHash);
				},
				{ passive: true }
			);
		});
		return;
	}

	// ===== SCROLL MODE =====
	const spySections = document.querySelectorAll("[data-spy-section]");
	if (spySections.length && spyNav) {
		const header = document.querySelector(".site-header");
		let isoInstance;

		const isoHandler = (entry) => {
			const spyLink = document.querySelector(`[data-spy-link][href="#${entry.target.id}"]`);
			if (!spyLink) return;
			if (entry.isIntersecting) {
				spyLink.classList.add(activeClass);
			} else {
				spyLink.classList.remove(activeClass);
			}
		};

		const isoOptions = () => {
			const navHeight = spyNav.offsetHeight || 0;
			const headerHeight = header?.offsetHeight || 0;
			const navCompStyles = window.getComputedStyle(spyNav);
			const navTop = navCompStyles.getPropertyValue("top");
			let navTopValue = 0;
			if (navTop.includes("px")) {
				navTopValue = Number(navTop.replace("px", ""));
			}
			const topOffset = Math.ceil(navHeight + headerHeight + navTopValue + 2);
			const bottomOffset = Math.ceil(window.innerHeight - topOffset);
			return { rootMargin: `-${topOffset}px 0px -${bottomOffset}px 0px` };
		};

		const iso = () => {
			if (typeof isoInstance === "object") {
				isoInstance.disconnect();
			}
			isoInstance = new IntersectionObserver((entries) => {
				entries.forEach(isoHandler);
			}, isoOptions());
			spySections.forEach((item) => isoInstance.observe(item));
		};

		const resizeObserver = new ResizeObserver((entries) =>
			entries.forEach((entry) => {
				if (entry.borderBoxSize[0]) {
					iso();
				}
			})
		);
		resizeObserver.observe(spyNav);
		const heightProbe = document.querySelector("[data-spy-window-height]");
		if (heightProbe) resizeObserver.observe(heightProbe);
	}

	const scrollContainer = document.querySelectorAll(".sticky-menu");
	if (scrollContainer.length) {
		scrollContainer.forEach((item) => {
			item.onwheel = function (e) {
				this.scrollLeft += e.deltaY * 0.5;
			};
			function checkScroll() {
				if (item.scrollWidth > item.clientWidth) {
					item.classList.add("has-scroll");
				} else {
					item.classList.remove("has-scroll");
				}
			}
			checkScroll();
			window.addEventListener("resize", checkScroll);
		});
	}
};

export default TargetMenu;
